module.exports = __webpack_public_path__ + "static/media/yield.e39f268f.svg";